import { CalendarEventAvailability } from '@griply/types';

const KNOWN = Object.values(CalendarEventAvailability);

// The seam that absorbs a newer backend's value — the callable response has no converter.
export const getExternalEventShowAs = (
  showAs?: unknown,
): CalendarEventAvailability =>
  KNOWN.includes(showAs as CalendarEventAvailability)
    ? (showAs as CalendarEventAvailability)
    : CalendarEventAvailability.Busy;
